const signing_keys = {
    title: 'کلیدهای امضا',
    description: 'کلیدهای امضای مورد استفاده برنامه‌های خود را به‌صورت امن مدیریت کنید.',
    private_key: 'کلیدهای خصوصی OIDC',
    private_keys_description: 'کلیدهای خصوصی OIDC برای امضای توکن‌های JWT استفاده می‌شوند.',
    cookie_key: 'کلیدهای کوکی OIDC',
    cookie_keys_description: 'کلیدهای کوکی OIDC برای امضای کوکی‌ها استفاده می‌شوند.',
    private_keys_in_use: 'کلیدهای خصوصی در حال استفاده',
    cookie_keys_in_use: 'کلیدهای کوکی در حال استفاده',
    rotate_private_keys: 'چرخش کلیدهای خصوصی',
    rotate_cookie_keys: 'چرخش کلیدهای کوکی',
    rotate_private_keys_description: 'این عمل یک کلید امضای خصوصی جدید ایجاد می‌کند، کلید فعلی را می‌چرخاند و کلید قبلی را حذف می‌کند. توکن‌های JWT امضاشده با کلید فعلی تا حذف یا چرخش بعدی معتبر می‌مانند.',
    rotate_cookie_keys_description: 'این عمل یک کلید کوکی جدید ایجاد می‌کند، کلید فعلی را می‌چرخاند و کلید قبلی را حذف می‌کند. کوکی‌های با کلید فعلی تا حذف یا چرخش بعدی معتبر می‌مانند.',
    select_private_key_algorithm: 'الگوریتم کلید امضا را برای کلید خصوصی جدید انتخاب کنید',
    rotate_button: 'چرخش',
    table_column: {
        id: 'شناسه',
        status: 'وضعیت',
        algorithm: 'الگوریتم کلید امضا',
        effective_at: 'زمان اعمال',
    },
    status: {
        next: 'بعدی',
        current: 'فعلی',
        previous: 'قبلی',
        effective_in: 'اعمال در {{time}}',
    },
    reminder: {
        rotate_private_key: 'آیا مطمئن هستید که می‌خواهید <strong>کلیدهای خصوصی OIDC</strong> را بچرخانید؟ توکن‌های JWT جدید با کلید جدید امضا می‌شوند. توکن‌های JWT موجود تا چرخش بعدی معتبر می‌مانند.',
        rotate_cookie_key: 'آیا مطمئن هستید که می‌خواهید <strong>کلیدهای کوکی OIDC</strong> را بچرخانید؟ کوکی‌های جدید در نشست‌های ورود با کلید کوکی جدید امضا می‌شوند. کوکی‌های موجود تا چرخش بعدی معتبر می‌مانند.',
        delete_private_key: 'آیا مطمئن هستید که می‌خواهید <strong>کلید خصوصی OIDC</strong> را حذف کنید؟ توکن‌های JWT موجود امضاشده با این کلید دیگر معتبر نخواهند بود.',
        delete_cookie_key: 'آیا مطمئن هستید که می‌خواهید <strong>کلید کوکی OIDC</strong> را حذف کنید؟ نشست‌های ورود قدیمی‌تر با کوکی‌های امضاشده با این کلید دیگر معتبر نخواهند بود. احراز هویت مجدد برای این کاربران لازم است.',
    },
    messages: {
        rotate_key_success: 'کلیدهای امضا با موفقیت چرخانده شدند.',
        delete_key_success: 'کلید با موفقیت حذف شد.',
    },
};
export default Object.freeze(signing_keys);
